import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import SmartTranslationEditor from './SmartTranslationEditor';

export default async function action() {
  return {
    title: 'Smart Translation Editor',
    component: (
      <AdminLayout>
        <SmartTranslationEditor />
      </AdminLayout>
    )
  };
}
